import { useAtom } from '@reatom/npm-react'
import { useMemo } from 'react'
import { styled } from 'styled-components'

import { Numeric } from '@blade/ui-kit'
import { PairMigrationStatus } from '@root/entities/pair/model'
import { FlashTextContentDistinct } from '@root/features/flash/flash-text-content-distinct'

import { PairInformationPoolItem } from './pair-information-pool-item'

import type { PairModel } from '@root/entities/pair'

type Props = {
  pair: PairModel
}

export const PairInformationBondingCurve: React.FC<Props> = ({ pair }) => {
  const [bondingCurve] = useAtom(pair.bondingPercentage)
  const [migrationStatus] = useAtom(pair.migrationStatus)

  const bondingPercentage = useMemo(() => {
    if (migrationStatus instanceof PairMigrationStatus.MigratedTo) {
      return 100
    }
    return bondingCurve
  }, [bondingCurve, migrationStatus])

  if (bondingPercentage === undefined) {
    return undefined
  }

  return (
    <Root title={'B.Curve'}>
      <FlashTextContentDistinct>
        <Numeric value={bondingPercentage} preset="percents" />
        <span>%</span>
      </FlashTextContentDistinct>
    </Root>
  )
}

const Root = styled(PairInformationPoolItem)`
  color: var(--success-9);
`
